// extracted by mini-css-extract-plugin
export default {"quickLinks":"brand-quick-links-QuickLinkTiles__quickLinks--1hkcN"};